import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Nosotros from "@/components/Nosotros";
import Servicios from "@/components/Servicios";
import Plataforma from "@/components/Plataforma";
import Beneficios from "@/components/Beneficios";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Landing() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".rp-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="relative">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Nosotros />
        <Servicios />
        <Plataforma />
        <Beneficios />
        <Contacto />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
